import React from "react";
import { map } from "lodash";

/** The Length of Involvement values the API accepts in `how_long`, in choice order. */
export const LENGTH_OF_INVOLVEMENT_VALUES = [
  "first_time",
  "less_than_1_year",
  "1_3_years",
  "more_than_3_years",
];

/**
 * Reads the `participant_feedback_how_long` URL value: comma-separated values.
 *
 * Unknown values are dropped. If no valid value is left, every value is included.
 * Returns the included values in choice order.
 */
export function parseLengthOfInvolvement(urlValue) {
  const values = urlValue === undefined || urlValue === null ? [] : String(urlValue).split(",");
  const included = LENGTH_OF_INVOLVEMENT_VALUES.filter((value) => values.includes(value));

  return included.length ? included : LENGTH_OF_INVOLVEMENT_VALUES;
}

/** Whether the selection leaves out at least one Length of Involvement. */
export function isLengthOfInvolvementFiltered(included) {
  return included.length < LENGTH_OF_INVOLVEMENT_VALUES.length;
}

/** The URL value for a selection; undefined (parameter removed) when every value is included. */
export function formatLengthOfInvolvement(included) {
  return isLengthOfInvolvementFiltered(included) ? included.join(",") : undefined;
}

/** The API's `how_long` for a selection; null when every value is included. */
export function lengthOfInvolvementPayload(included) {
  return isLengthOfInvolvementFiltered(included) ? included : null;
}

/**
 * The selection's labels, comma-separated; null when every value is included.
 * `labels` is the participant_feedback response's `fields.how_long`.
 */
export function lengthOfInvolvementLabel(included, labels) {
  return isLengthOfInvolvementFiltered(included)
    ? included.map((value) => labels[value]).join(", ")
    : null;
}

/**
 * The Participant Feedback section's Length of Involvement checkboxes.
 *
 * `labels` maps each Length of Involvement value to its label, as returned in the
 * participant_feedback response's `fields.how_long`. `value` is the included values.
 * The last ticked box is disabled so at least one value always stays included.
 */
export const LengthOfInvolvementFilter = ({ labels, value, onChange }) => {
  function onToggle(optionValue, isChecked) {
    const next = LENGTH_OF_INVOLVEMENT_VALUES.filter((v) =>
      v === optionValue ? isChecked : value.includes(v)
    );

    if (next.length) {
      onChange(next);
    }
  }

  return (
    <div className="form-group">
      <div className="tw-mb-2">Length of Involvement</div>
      {map(labels, (label, optionValue) => {
        const id = `participant-feedback-how-long-${optionValue}`;
        const isChecked = value.includes(optionValue);

        return (
          <div key={optionValue} className="form-check form-check-inline">
            <input
              type="checkbox"
              className="form-check-input"
              id={id}
              checked={isChecked}
              disabled={isChecked && value.length === 1}
              onChange={(e) => onToggle(optionValue, e.target.checked)}
            />
            <label className="form-check-label" htmlFor={id}>
              {label}
            </label>
          </div>
        );
      })}
    </div>
  );
};
